(() => {
  let animationFrame;

  const CARD_SELECTOR = '.card__container';
  const GROUP_SELECTOR = '.collection__grid, .swiper-wrapper';

  function isVisible(element) {
    if (!element) return false;

    const style = window.getComputedStyle(element);
    const rect = element.getBoundingClientRect();

    return (
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      rect.width > 0 &&
      rect.height > 0
    );
  }

  function getInfoBlock(card) {
    return card.querySelector('.garvin-product-card > a.card');
  }

  function getVisibleQuickAdd(card) {
    const quickAdds = card.querySelectorAll(
      '.card__quick-add-container--desktop, .card__quick-add-container--mobile'
    );

    return Array.from(quickAdds).find(isVisible);
  }

  function getCardsInGroup(group) {
    return Array.from(group.querySelectorAll(CARD_SELECTOR)).filter((card) => {
      const closestGroup = card.closest(GROUP_SELECTOR);
      const infoBlock = getInfoBlock(card);
      const quickAdd = getVisibleQuickAdd(card);

      return closestGroup === group && infoBlock && quickAdd;
    });
  }

  function splitCardsByRow(cards, isGrid) {
    if (!isGrid) return [cards];

    const rows = [];

    cards.forEach((card) => {
      const cardTop = Math.round(card.getBoundingClientRect().top);

      let row = rows.find((item) => Math.abs(item.top - cardTop) <= 4);

      if (!row) {
        row = {
          top: cardTop,
          cards: []
        };

        rows.push(row);
      }

      row.cards.push(card);
    });

    return rows.map((row) => row.cards);
  }

  function alignButtons(cards) {
    if (cards.length < 2) return;

    /* Reinicia medidas anteriores antes de recalcular */
    cards.forEach((card) => {
      const infoBlock = getInfoBlock(card);

      if (infoBlock) {
        infoBlock.style.minHeight = '';
      }
    });

    const measurements = cards
      .map((card) => {
        const infoBlock = getInfoBlock(card);
        const quickAdd = getVisibleQuickAdd(card);

        if (!infoBlock || !quickAdd) return null;

        const cardRect = card.getBoundingClientRect();
        const quickAddRect = quickAdd.getBoundingClientRect();
        const infoRect = infoBlock.getBoundingClientRect();

        return {
          infoBlock,
          buttonPosition: quickAddRect.top - cardRect.top,
          infoHeight: infoRect.height
        };
      })
      .filter(Boolean);

    if (measurements.length < 2) return;

    const targetPosition = Math.max(
      ...measurements.map((item) => item.buttonPosition)
    );

    measurements.forEach((item) => {
      const difference = Math.ceil(
        targetPosition - item.buttonPosition
      );

      if (difference > 0) {
        item.infoBlock.style.minHeight = `${Math.ceil(
          item.infoHeight + difference
        )}px`;
      }
    });
  }

  function runAlignment() {
    document.querySelectorAll(GROUP_SELECTOR).forEach((group) => {
      const cards = getCardsInGroup(group);

      if (cards.length < 2) return;

      const isGrid = group.classList.contains('collection__grid');
      const rows = splitCardsByRow(cards, isGrid);

      rows.forEach(alignButtons);
    });
  }

  function scheduleAlignment() {
    window.cancelAnimationFrame(animationFrame);

    animationFrame = window.requestAnimationFrame(() => {
      window.requestAnimationFrame(runAlignment);
    });
  }

  document.addEventListener('DOMContentLoaded', scheduleAlignment);
  window.addEventListener('load', scheduleAlignment);
  window.addEventListener('resize', scheduleAlignment);

  document.addEventListener('shopify:section:load', scheduleAlignment);
  document.addEventListener('shopify:section:reorder', scheduleAlignment);

  new MutationObserver(scheduleAlignment).observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  scheduleAlignment();
})();

/* =====================================================================
   GARVIN · INDICADOR DE SCROLL EN CARRUSELES DE PRODUCTO (solo móvil)
   15/10/2026
   - Barra de progreso bajo cada carrusel con tarjetas (.card__container).
     Se oculta sola si no hay nada más que ver.
   - "Empujón" único: la primera vez que el carrusel entra en pantalla se
     desliza ~56px y vuelve, para indicar que se puede deslizar.
     No se repite si la clienta ya ha deslizado algún carrusel.
     Respeta "reducir movimiento" del sistema.
   - Estilos en assets/custom.css (.garvin-scroll-indicator).
   ===================================================================== */
(() => {
  if (window.__garvinCarouselHint) return;
  window.__garvinCarouselHint = true;
  if (!('IntersectionObserver' in window)) return;

  const mq = window.matchMedia('(max-width: 749.98px)');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const ready = new WeakMap();
  let userHasSwiped = false;

  function getSwiper(slider) {
    const container = slider.querySelector('[data-swiper]');
    return slider.swiper || (container && container.swiper) || null;
  }

  function setup(slider) {
    if (ready.has(slider)) return ready.get(slider);

    const swiper = getSwiper(slider);
    if (!swiper || swiper.destroyed) return null;

    const bar = document.createElement('div');
    bar.className = 'garvin-scroll-indicator';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<span class="garvin-scroll-indicator__thumb"></span>';
    const container = slider.querySelector('[data-swiper]') || swiper.el;
    container.insertAdjacentElement('afterend', bar);
    const thumb = bar.firstElementChild;

    const update = () => {
      const total = swiper.virtualSize || 0;
      const visible = swiper.size || 0;
      const scrollable = !swiper.isLocked && total > visible + 2;

      bar.hidden = !scrollable;
      if (!scrollable) return;

      const trackW = bar.clientWidth;
      const ratio = Math.min(1, visible / total);
      const thumbW = Math.max(trackW * 0.28, trackW * ratio);
      const progress = Math.min(1, Math.max(0, swiper.progress || 0));

      thumb.style.width = `${thumbW}px`;
      thumb.style.transform = `translateX(${(trackW - thumbW) * progress}px)`;
    };

    swiper.on('progress', update);
    swiper.on('resize', update);
    swiper.on('update', update);
    swiper.on('touchStart', () => {
      userHasSwiped = true;
    });

    const api = { swiper, update };
    ready.set(slider, api);
    update();
    return api;
  }

  function nudge(swiper) {
    if (userHasSwiped || reduceMotion.matches || !mq.matches) return;
    if (swiper.isLocked || Math.abs(swiper.translate || 0) > 1) return;

    const wrapper = swiper.wrapperEl;
    if (!wrapper || typeof wrapper.animate !== 'function') return;

    const base = 'translate3d(0px, 0px, 0px)';
    const animation = wrapper.animate(
      [
        { transform: base },
        { transform: 'translate3d(-56px, 0px, 0px)', offset: 0.45 },
        { transform: base }
      ],
      { duration: 1100, delay: 350, easing: 'cubic-bezier(.4, 0, .2, 1)' }
    );

    swiper.el.addEventListener('touchstart', () => animation.cancel(), {
      once: true,
      passive: true
    });
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting || !mq.matches) return;

        const slider = entry.target;
        const api = setup(slider);

        if (!api) {
          /* Swiper aún no inicializado: reintentar */
          setTimeout(() => {
            observer.unobserve(slider);
            observer.observe(slider);
          }, 400);
          return;
        }

        observer.unobserve(slider);
        if (!api.swiper.virtualSize) api.swiper.update();
        api.update();
        nudge(api.swiper);
      });
    },
    { threshold: 0.5 }
  );

  function scan() {
    document.querySelectorAll('slideshow-section').forEach((slider) => {
      if (slider.dataset.garvinHint) return;
      if (!slider.querySelector('.card__container')) return;
      slider.dataset.garvinHint = '1';
      observer.observe(slider);
    });
  }

  document.addEventListener('DOMContentLoaded', scan);
  window.addEventListener('load', scan);
  document.addEventListener('shopify:section:load', scan);
  scan();
})();
